import React, { Component } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { withStyles, TableCell, TableRow } from '@material-ui/core'

import * as CONSTANTS from '../../../utils/constants'
import { formatNumber } from '../../../utils/helpers'

const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/
const MAX_VALUE_LENGTH = 100

const styles = theme => ({
    change: {
        fontSize: 12,
        whiteSpace: 'nowrap'
    },
    changeField: {
        fontWeight: 500
    }
})

class TraceList extends Component {

    formatValue = (field, value) => {
        const stockLanguage = this.props.language.stock

        if (value === null || value === undefined) return '-'
        if (typeof value === 'boolean') return value ? this.props.traceLanguage.yes : this.props.traceLanguage.no
        if (Array.isArray(value)) {
            const labels = field === 'tags' ? stockLanguage.tagsLabel : field === 'stockStatus' ? stockLanguage.statusLabel : {}
            return value.length ? value.map(entry => labels[entry] || entry).join(', ') : '-'
        }
        if (field === 'type') return stockLanguage.typeLabel[value] || value
        if (typeof value === 'number') return field.endsWith('Id') ? value : formatNumber(value)
        if (ISO_DATE_REGEX.test(value)) return moment(value).format(CONSTANTS.DEFAULT_DATE_FORMAT)

        const text = String(value)
        return text.length > MAX_VALUE_LENGTH ? `${text.slice(0, MAX_VALUE_LENGTH)}...` : text
    }

    renderChanges = () => {
        const { changes } = this.props.item
        if (!changes) return '-'

        return Object.keys(changes).map(field => (
            <div key={field} className={this.props.classes.change}>
                <span className={this.props.classes.changeField}>{this.props.traceLanguage.fields[field] || field}</span>: {this.formatValue(field, changes[field].from)} &rarr; {this.formatValue(field, changes[field].to)}
            </div>
        ))
    }

    render() {
        const { stockData, author } = this.props.item
        const carBrandName = stockData && stockData.carBrand ? stockData.carBrand.name : ''
        const carModelName = stockData && stockData.carModel ? stockData.carModel.name : ''

        return (
            <TableRow onClick={() => this.props.onSelect(this.props.item.stockDataId)}>
                <TableCell>{this.props.item.stockDataId}</TableCell>
                <TableCell>{carBrandName || carModelName ? `${carBrandName} ${carModelName}` : '-'}</TableCell>
                <TableCell>{author && author.fullName ? author.fullName : '-'}</TableCell>
                <TableCell>{this.props.item.action}</TableCell>
                <TableCell>{moment(this.props.item.createdAt).format(CONSTANTS.DEFAULT_DATE_TIME_FORMAT)}</TableCell>
                <TableCell>{this.renderChanges()}</TableCell>
            </TableRow>
        )
    }
}

const mapStateToProps = state => ({
    language: state.languageReducer.i18n.itemDetails,
    traceLanguage: state.languageReducer.i18n.trace
})

const mapDispatchToProps = dispatch => ({

})

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(TraceList))
